//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      sendForm: {
        username: 'FairyEver',
        userid: '001'
      },
      rules: {
        username: [{
          required: true,
          message: '请输入要发送的用户名',
          trigger: 'blur'
        }],
        userid: [{
          required: true,
          message: '请输入要发送的用户ID',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleSubmit: function handleSubmit(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$router.push({
            name: 'demo-playground-page-argu-get',
            params: {
              username: _this.sendForm.username
            },
            query: {
              userid: _this.sendForm.userid
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};